
import "./account.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* formulário */
import { useForm } from "react-hook-form";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { collection, addDoc, doc, updateDoc, runTransaction, serverTimestamp } from "firebase/firestore";
import { getAuth, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";

/* funções auxiliares */
import { expiryDate, showError, clearError, formError, validarCPFouCNPJ, registerLog, levelPassword, firstName, wait, checkEmailExists, db_basic } from "../../services/functions/functions.ts";

/* validação de campos */
import { maskdocumento, masktelefone } from "../../services/masks/masks.ts";

/* imagens */
import icon_success from "../../assets/sucesso.png";

/* navegação */
import { Link, useNavigate } from "react-router-dom";

/* endpoints */
import { ENDPOINTS } from "../../routes/endpoints.js";


export default function Account() {

    const [basic, setBasic] = useState([]);
    const [loadBasic, setLoadBasic] = useState(true);

    const [step, setStep] = useState(0);
    const [error, setError] = useState("0");
    const [documento, setDocumento] = useState(false);
    const [levelPass, setLevelPass] = useState("");
    const [client, setClient] = useState([]);
    const [alteraItem, setAlteraItem] = useState(0);

    /* refs para tratamento de erros */
    const refEmpresa = useRef(null);
    const refLabelEmpresa = useRef(null);
    const refErrorEmpresa = useRef(null);

    const refResponsavel = useRef(null);
    const refLabelResponsavel = useRef(null);
    const refErrorResponsavel = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);

    const refDocumento = useRef(null);
    const refLabelDocumento = useRef(null);

    const refEmail = useRef(null);
    const refLabelEmail = useRef(null);
    const refErrorEmail = useRef(null);

    const refSenhaEmail = useRef(null);
    const refLabelSenhaEmail = useRef(null);

    const refSenha = useRef(null);
    const refLabelSenha = useRef(null);
    const refErrorSenha = useRef(null);

    const refNovaSenha = useRef(null);
    const refLabelNovaSenha = useRef(null);
    const refErrorNovaSenha = useRef(null);

    const refConfNovaSenha = useRef(null);
    const refLabelConfNovaSenha = useRef(null);

    const tokenRef = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
    const refErrorToken = useRef(null);    

    const refErroCadastro = useRef(null);
    const refErroEmail = useRef(null);
    const refErroSenha = useRef(null);
    const refLoad = useRef(null);
    /* -- */


    const [isPending, startTransition] = useTransition();
    const [isUpdate, setIsUpdate] = useState(false);

    const [token, setToken] = useState("00000");
    const [counter, setCounter] = useState(1);

    const navigate = useNavigate();

    useEffect(() => { const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000); return () => clearInterval(timer); }, [counter]);

    const { handleSubmit, register, getValues, setValue, watch } = useForm();

    function formatMinutes(t) {

        var p1 = Math.trunc(t / 60);
        var p2 = t - (p1 * 60);

        p1 > -1 && p1 < 10 ? (p1 = '0' + p1.toString()) : p1 = p1.toString();
        p2 > -1 && p2 < 10 ? (p2 = '0' + p2.toString()) : p2 = p2.toString();

        return p1 + ':' + p2;
    }

    async function send_token(e) {

        e.preventDefault();

        if(counter > 0) {

            setError("token");
            refErrorToken.current.innerHTML = "Só é permitido o envio de novo token após o tempo do atual expirar.";
            refErrorToken.current.style.height = "1.5rem";
            return;

        } else {

            if(error === "token") {
                refErrorToken.current.innerHTML = "";
                refErrorToken.current.style.height = "0";
                for(let i = 1; i < 6; i++) { setValue("tk" + i, ""); }
            }
        
            const n = [4];
            
            n[0] = parseInt(Math.random() * 9);
            n[1] = parseInt(Math.random() * 9);
            n[2] = parseInt(Math.random() * 9);
            n[3] = parseInt(Math.random() * 9);
            n[4] = parseInt(Math.random() * 9);

            let tk = n[0].toString() + n[1].toString() + n[2].toString() + n[3].toString() + n[4].toString();
            setToken(tk);

            //envia email            
            let ma = getValues("email");
            let pnm = firstName(basic.client.responsavel);

            const response = await fetch(ENDPOINTS.email.validToken, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({nome: pnm, email: ma, token: tk}),
            });

            const data = await response.json();
            if(data.status !== "success") {
                formError(refErroEmail, JSON.stringify(data.message), true);
                return;
            }

            setCounter(299);

        }

    }


    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {

            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);

            //carrega campos
            setValue("empresa", bbd.client.empresa || "");
            setValue("responsavel", bbd.client.responsavel || "");
            setValue("telefone", bbd.client.telefone || "");
            setValue("documento", bbd.client.documento || "");
            setValue("email", bbd.client.email || "");

            if(bbd.client.documento !== null) {
                setDocumento(true);
            }

            registerLog(uid, "/page/account");

            setLoadBasic(false);
        };

        loadBasic();

    }, []);



    async function alterar_cadastro(data) {

        formError(refErroCadastro, "", false);

        const v_nome = (nome) => { let validade = /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi; return validade.test(nome); }

        let ep = getValues("empresa");
        if(!v_nome(ep)) {
            showError(refEmpresa, refLabelEmpresa, refErrorEmpresa, "Esse nome de empresa não é valido, por favor verifique a digitação", setError, "empresa");
            return;
        }

        let nm = getValues("responsavel");
        if(!v_nome(nm)) {
            showError(refResponsavel, refLabelResponsavel, refErrorResponsavel, "Insira o nome completo do responsável (nome e sobrenome)", setError, "responsavel");
            return;
        }

        let tl = getValues("telefone");
        if(tl.length < 15) {
            showError(refTelefone, refLabelTelefone, refErrorTelefone, "Telefone inválido, digite o ddd + telefone", setError, "telefone");
            return;
        }
        
        let dc = getValues("documento");
        if(documento) {

            if(dc.length !== 14 && dc.length !== 18) {
                showError(refDocumento, refLabelDocumento, refErrorTelefone, "Insira um CPF ou CNPJ com todos os dígitos.", setError, "documento");
                return;
            }

            if(!validarCPFouCNPJ(dc)) {
                showError(refDocumento, refLabelDocumento, refErrorTelefone, "Esse número de CPF ou CNPJ é inválido.", setError, "documento");
                return;
            }
        
        }

        if(basic.client.empresa === ep && basic.client.responsavel === nm && basic.client.telefone === tl && (!documento || basic.client.documento === dc)) {
            formError(refErroCadastro, "Não foi realizada nenhuma alteração nos dados cadastrais.", true);
        } else {

            setIsUpdate(true);

            try{
                
                const uid = basic.client.idDoc;
                const clientRef = doc(db, "db_client", uid);

                await runTransaction(db, async (transaction) => {

                    const clientSnap = await transaction.get(clientRef);

                    const clientAtual = clientSnap.data();
                    const agora = new Date();

                    //1. salva histórico
                    const histRef = doc(collection(db, "hs_client"));

                    transaction.set(histRef, {
                        ...clientAtual,
                        data_inicio_vigencia: clientAtual.data_atualizacao,
                        data_fim_vigencia: agora,
                        archived_at: serverTimestamp()
                    });

                    //2. atualiza documento principal
                    transaction.update(clientRef, {
                        data_atualizacao: agora,
                        empresa: ep,
                        responsavel: nm,
                        telefone: tl,
                        ...(documento && { documento: dc })
                    });

                });

                // *** precisa implementar a alteração no AgentsContents 

                registerLog(uid, "/account/dados_cadastrais");

                setAlteraItem(1);

                setStep(2);
                window.scrollTo(0, 0);
                
            }
            catch(erro) {
                formError(refErroCadastro, erro, true);
            }
            finally {
                setIsUpdate(false);
            }
            
        }
                
    }



    async function alterar_email(data) {

        formError(refErroEmail, "", false);

        const v_email = (email) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(email); }

        let ma = getValues("email");
        if(!v_email(ma)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        let sm = getValues("senhaemail");
        if(sm.length < 6) {
            showError(refSenhaEmail, refLabelSenhaEmail, refErrorEmail, "Para alterar seu email é necessário digitar sua senha atual", setError, "senhaemail");
            return;
        }

        if(basic.client.email === ma) {
            formError(refErroEmail, "Não foi realizada nenhuma alteração no email.", true);
        } else {

            try {

                setIsUpdate(true);

                const exists = await checkEmailExists(ma);
                if(exists) {
                    showError(refEmail, refLabelEmail, refErrorEmail, "Esse email já consta em nosso cadastro, não pode ser usado novamente", setError, "email");
                    return;
                }

                const auth = getAuth();
                const user = auth.currentUser;

                const credential = EmailAuthProvider.credential(user.email, sm);
                await reauthenticateWithCredential(user, credential);

                // cria o token e dispara o email
                const n = [4];
                
                n[0] = parseInt(Math.random() * 9);
                n[1] = parseInt(Math.random() * 9);
                n[2] = parseInt(Math.random() * 9);
                n[3] = parseInt(Math.random() * 9);
                n[4] = parseInt(Math.random() * 9);

                let tk = n[0].toString() + n[1].toString() + n[2].toString() + n[3].toString() + n[4].toString();
                setToken(tk);

                //envia email para o cliente
                let pnm = firstName(basic.client.responsavel);

                const response = await fetch(ENDPOINTS.email.validToken, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({nome: pnm, email: ma, token: tk}),
                });
                
                const data = await response.json();
                if(data.status !== "success") {
                    formError(refErroEmail, JSON.stringify(data.message), true);
                    return;
                }
                
                setStep(1);
                window.scrollTo(0, 0);

                setCounter(299);

            }
            catch(erro) {
                showError(refSenhaEmail, refLabelSenhaEmail, refErrorEmail, "Senha atual inválida: " + erro, setError, "senhaemail");
                return;
            }
            finally {
                setIsUpdate(false);
            }
        
        }

    }



    async function validar_token(data) {

        formError(refErroEmail, "", false);

        let tk1 = getValues("tk1");
        let tk2 = getValues("tk2");
        let tk3 = getValues("tk3");
        let tk4 = getValues("tk4");
        let tk5 = getValues("tk5");
        
        let tk = tk1.toString() + tk2.toString() + tk3.toString() + tk4.toString() + tk5.toString();

        if(counter === 0) {
            setError("token");
            refErrorToken.current.innerHTML = "O tempo de validade do seu token expirou, clique em reenviar";
            refErrorToken.current.style.height = "1.5rem";
            return;
        }

        if(tk !== token) {
            setError("token");
            refErrorToken.current.innerHTML = "O token informado não está correto, verifique se é o último que você recebeu";
            refErrorToken.current.style.height = "1.5rem";
            for(let i = 1; i < 6; i ++) {
                tokenRef[i - 1].current.style.backgroundColor = "yellow";
            }
            return;
        }

        try {

            setIsUpdate(true);

            setCounter(0);

            const auth = getAuth();
            const token = await auth.currentUser.getIdToken();
            
            const resEmail = await fetch(ENDPOINTS.firebase.updateEmail, {
                method: "POST",
                headers: {"Content-Type": "application/json", "Authorization": `Bearer ${token}`,},
                body: JSON.stringify({ new_email: getValues("email") }),
            });

            const resultEmail = await resEmail.json();
            if (resultEmail.error) {
                formError(refErroEmail, resultEmail.message, true);
                return;
            }

            wait(500);

            let ma = getValues("email");

            const uid = basic.client.idDoc;
            const clientRef = doc(db, "db_client", uid);

            await runTransaction(db, async (transaction) => {

                const clientSnap = await transaction.get(clientRef);

                const clientAtual = clientSnap.data();
                const agora = new Date();

                //1. salva histórico
                const histRef = doc(collection(db, "hs_client"));

                transaction.set(histRef, {
                    ...clientAtual,
                    data_inicio_vigencia: clientAtual.data_atualizacao,
                    data_fim_vigencia: agora,
                    archived_at: serverTimestamp()
                });

                //2. atualiza documento principal
                transaction.update(clientRef, {
                    email: ma,
                    data_atualizacao: agora
                });

            });

            wait(500);

            registerLog(uid, "/account/email");

            setAlteraItem(2);

            setStep(2);
            window.scrollTo(0, 0);
            
        }
        catch(erro) {
            formError(refErroEmail, "Não foi possível alterar o e-mail: " + erro, true);
            return;
        }
        finally {
            setIsUpdate(false);
        }

    }



    async function alterar_senha(data) {

        formError(refErroSenha, "", false);

        let uid = basic.client.id;
    
        let sn = getValues("senha");
        if(sn.length < 6) {
            showError(refSenha, refLabelSenha, refErrorSenha, "A senha atual deve ter entre 6 e 12 caracteres", setError, "senha");
            return;
        }
    
        let ns = getValues("novasenha");
        if(ns.length < 6) {
            showError(refNovaSenha, refLabelNovaSenha, refErrorNovaSenha, "A nova senha deve ter entre 6 e 12 caracteres", setError, "novasenha");
            return;                
        }

        let cs = getValues("confnovasenha");
        if(ns !== cs) {
            showError(refConfNovaSenha, refLabelConfNovaSenha, refErrorNovaSenha, "A senha de confirmação deve ser idêntica a que você redefiniu", setError, "confnovasenha");
            return;
        }

        if(sn === ns) {
            formError(refErroSenha, "Não foi realizada nenhuma alteração na senha.", true);
        } else {

            try {

                setIsUpdate(true);

                const auth = getAuth();
                const user = auth.currentUser;

                const token = await auth.currentUser.getIdToken();

                const credential = EmailAuthProvider.credential(user.email, sn);
                await reauthenticateWithCredential(user, credential);
                
                const resPassword = await fetch(ENDPOINTS.firebase.updatePassword, {
                    method: "POST",
                    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${token}`,},
                    body: JSON.stringify({new_password: ns}),
                });

                const resultPassword = await resPassword.json();
                if(resultPassword.error) {
                    formError(refErroSenha, resultPassword.message, true);
                    return;
                }

                wait(500);

                registerLog(uid, "/account/password");

                setAlteraItem(3);

                setStep(2);
                window.scrollTo(0, 0);

            }
            catch(erro) {
                showError(refSenha, refLabelSenha, refErrorSenha, "Senha atual inválida: " + erro, setError, "senha");
                return;
            }
            finally {
                setIsUpdate(false);
            }

        }

    }


    const handleChange = (e, index) => {
        if (e.target.value.length === 1 && tokenRef[index]?.current) {
            tokenRef[index].current.focus();
        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && tokenRef[index]?.current) {
            tokenRef[index].current.focus();
        }
    };


    function clearErrorToken() {

        if(error === "token") {

            refErrorToken.current.innerHTML = "";
            refErrorToken.current.style.height = "0";

            for(let i = 1; i < 6; i ++) {
                tokenRef[i - 1].current.style.backgroundColor = "";
            }

            setError("0");
        }

    }


    function back_step() {
        setStep(0);
    }
    
    

    return(
        <div className="context">
                            
            <Header access={1}></Header>
            
            <div className="content">

            { step === 0 && 
                (
                <>
                <div className="ft_topico">Alteração de informações</div>
                <div className="ft_descricao">Altere seus dados, para algumas informações específicas será necessário realizar uma validação.</div>
                <div className="space"></div>

                { loadBasic ? (
                <>
                <div className="border_form account_border_form">
                    <span ref={refLoad} className="load_form">aguarde carregando formulário ...</span>
                </div>
                </>
                ) : (
                <>
                <div className="border_form account_border_form">
                    <form className="form" onSubmit={handleSubmit(alterar_cadastro)}>
                        <span className="title_form">Dados cadastrais</span>
                        <span className="subtitle_form">Altere suas informações cadastrais</span>

                            <span ref={refErrorEmpresa} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelEmpresa}>
                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("empresa")} ref={(el) => {refEmpresa.current = el; register("empresa").ref(el);}} onClick={() => clearError(refEmpresa, refLabelEmpresa, refErrorEmpresa, error, setError)} onChange={() => clearError(refEmpresa, refLabelEmpresa, refErrorEmpresa, error, setError)}></input>
                            <span className="label">Nome da Empresa</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                            <span ref={refErrorResponsavel} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelResponsavel}>
                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("responsavel")} ref={(el) => {refResponsavel.current = el; register("responsavel").ref(el);}} onClick={() => clearError(refResponsavel, refLabelResponsavel, refErrorResponsavel, error, setError)} onChange={() => clearError(refResponsavel, refLabelResponsavel, refErrorResponsavel, error, setError)}></input>
                            <span className="label">Nome do Responsável</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                        <span ref={refErrorTelefone} className="error_form"></span>
                        <div className="account_box">
                            <div className="account_box_1a">
                                <label for="inp" className="inp" ref={refLabelTelefone}>
                                <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone")} ref={(el) => {refTelefone.current = el; register("telefone").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError);}}}></input>
                                <span className="label">Telefone</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="account_box_1b"></div>
                            <div className="account_box_1a">
                                <label for="inp" className="inp" ref={refLabelDocumento}>
                                <input type="text" placeholder="&nbsp;" maxLength={18} {...register("documento")} ref={(el) => {refDocumento.current = el; register("documento").ref(el);}} onClick={() => clearError(refDocumento, refLabelDocumento, refErrorTelefone, error, setError)} onChange={(e) => {if (error === "0") {setValue("documento", maskdocumento(e.target.value));} else {clearError(refDocumento, refLabelDocumento, refErrorTelefone, error, setError);}}} disabled={!documento}></input>
                                <span className="label">CPF ou CNPJ</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                        </div>
                        <span className="space_form"></span>
                        <span ref={refErroCadastro} className="error_form"></span>
                        <span className="space_form"></span>
                        <button type="submit" name="bt1" className="button_form" disabled={isUpdate}>{isUpdate ? "AGUARDE ..." : "ALTERAR CADASTRO"}</button>
                            
                    </form>
                </div>

                <div className="space"></div>

                <div className="border_form account_border_form">
                    <form className="form" onSubmit={handleSubmit(alterar_email)}>

                        <span className="title_form">Email</span>
                        <div className="account_title_box">
                            <span className="subtitle_form">Altere seu email.&nbsp;</span>
                            <span className="account_aviso">(necessita da senha atual, validação do novo email e fazer login)</span>
                        </div>

                        <span ref={refErrorEmail} className="error_form"></span>
                        <div className="account_box">
                            <div className="account_box_2a">
                                <label for="inp" className="inp" ref={refLabelEmail}>
                                <input type="text" placeholder="&nbsp;" maxLength={40} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                                <span className="label">Email</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="account_box_2b"></div>
                            <div className="account_box_2c">
                                <label for="inp" className="inp" ref={refLabelSenhaEmail}>
                                <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senhaemail")} ref={(el) => {refSenhaEmail.current = el; register("senhaemail").ref(el);}} onClick={() => clearError(refSenhaEmail, refLabelSenhaEmail, refErrorEmail, error, setError)} onChange={() => clearError(refSenhaEmail, refLabelSenhaEmail, refErrorEmail, error, setError)}></input>
                                <span className="label">Senha Atual</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                        </div>
                    
                        <span className="space_form"></span>
                        <span ref={refErroEmail} className="error_form"></span>
                        <span className="space_form"></span>
                        <button type="submit" name="bt2" className="button_form" disabled={isUpdate}>{isUpdate ? "AGUARDE ..." : "ALTERAR EMAIL"}</button>
                            
                    </form>
                </div>

                <div className="space"></div>

                <div className="border_form account_border_form">
                    <form className="form" onSubmit={handleSubmit(alterar_senha)}>
                        <span className="title_form">Redefinir Senha</span>
                        <div className="account_title_box">
                            <span className="subtitle_form">Redefina sua senha.&nbsp;</span>
                            <span className="account_aviso">(necessita da senha atual e fazer login)</span>
                        </div>

                        <span ref={refErrorSenha} className="error_form"></span>
                        <div className="account_box">
                            <div className="account_box_1a">
                                <label for="inp" className="inp" ref={refLabelSenha}>
                                <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senha")} ref={(el) => {refSenha.current = el; register("senha").ref(el);}} onClick={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onChange={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)}></input>
                                <span className="label">Senha Atual</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="account_box_1b"></div>
                            <div className="account_box_1a"></div>
                        </div>
                        <span className="space_form account_space_form"></span>

                        <span ref={refErrorNovaSenha} className="error_form"></span>
                        <div className="account_box">
                            <div className="account_box_1a">
                                <label for="inp" className="inp" ref={refLabelNovaSenha}>
                                <input type="password" placeholder="&nbsp;" maxLength={12} {...register("novasenha")} ref={(el) => {refNovaSenha.current = el; register("novasenha").ref(el);}} onClick={() => clearError(refNovaSenha, refLabelNovaSenha, refErrorNovaSenha, error, setError)} onChange={(e) => {if (error === "0") {setLevelPass(e.target.value);} else {clearError(refNovaSenha, refLabelNovaSenha, refErrorNovaSenha, error, setError);}}}></input>
                                <span className="label">Nova Senha</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="account_box_1b"></div>
                            <div className="account_box_1a">
                                <label for="inp" className="inp" ref={refLabelConfNovaSenha}>
                                <input type="password" placeholder="&nbsp;" maxLength={12} {...register("confnovasenha")} ref={(el) => {refConfNovaSenha.current = el; register("confnovasenha").ref(el);}} onClick={() => clearError(refConfNovaSenha, refLabelConfNovaSenha, refErrorNovaSenha, error, setError)} onChange={() => clearError(refConfNovaSenha, refLabelConfNovaSenha, refErrorNovaSenha, error, setError)}></input>
                                <span className="label">Confirma a Nova Senha</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                        </div>
                        <span className="space_form"></span>

                        <span className="account_aviso_senha">Nível da Senha:&nbsp;<span className="account_nivel_senha">{levelPassword(levelPass)}</span></span>

                        <span className="space_form"></span>
                        <span ref={refErroSenha} className="error_form"></span>
                        <span className="space_form"></span>
                        <button type="submit" name="bt3" className="button_form" disabled={isUpdate}>{isUpdate ? "AGUARDE ..." : "REDEFINIR A SENHA"}</button>
                    </form>
                </div>    
                </>
                )}
                </>
                )}

                { step === 1 && 
                (
                <>
                <div className="ft_topico">Alteração de email</div>
                <div className="ft_descricao">Altere seus dados, para algumas informações específicas será necessário realizar uma validação.</div>
                <div className="space"></div>
                <div className="border_form account_border_form">
                    <form className="form" onSubmit={handleSubmit(validar_token)}>
                        <span className="title_form">Validação do novo email</span>
                        <span className="subtitle_form">{firstName(getValues("responsavel"))}, por motivo de segurança, precisamos confirmar a proprietariedade desse email.</span>
                        <span className="subtitle_form">Por isso, enviamos um token no seu novo email para que você possa validar antes de prosseguir.</span>
                        <span className="space_form"></span>

                        <span ref={refErrorToken} className="account_error_form" style={{justifyContent: "start"}}></span>
                        <div className="account_token_box">
                            <div className="account_token">
                                <div className="account_token_group">
                                    <span className="account_token_item"><input type="text" className="account_token_input" {...register("tk1")} ref={ (el) => {tokenRef[0].current = el; register("tk1").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 1) } onClick={clearErrorToken}></input></span>
                                    <span className="account_token_item"><input type="text" className="account_token_input" {...register("tk2")} ref={ (el) => {tokenRef[1].current = el; register("tk2").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 2) } onKeyDown={ (e) => handleKeyDown(e, 0) } onClick={clearErrorToken}></input></span>
                                    <span className="account_token_item"><input type="text" className="account_token_input" {...register("tk3")} ref={ (el) => {tokenRef[2].current = el; register("tk3").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 3) } onKeyDown={ (e) => handleKeyDown(e, 1) } onClick={clearErrorToken}></input></span>
                                    <span className="account_token_item"><input type="text" className="account_token_input" {...register("tk4")} ref={ (el) => {tokenRef[3].current = el; register("tk4").ref(el);} } maxLength={1} onChange={ (e) => handleChange(e, 4) } onKeyDown={ (e) => handleKeyDown(e, 2) } onClick={clearErrorToken}></input></span>
                                    <span className="account_token_item"><input type="text" className="account_token_input" {...register("tk5")} ref={ (el) => {tokenRef[4].current = el; register("tk5").ref(el);} } maxLength={1} onKeyDown={ (e) => handleKeyDown(e, 3) } onClick={clearErrorToken}></input></span>
                                </div>
                            </div>
                            <div className="account_cronometer">{ formatMinutes(counter) }</div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        <span className="subtitle_form">Não recebeu seu token ou não deu tempo de digitar?</span>
                        <div className="account_send_token" onClick={send_token}>Clique aqui para enviar outro token</div>
                        <span className="space_form"></span>
                        <span ref={refErroEmail} className="error_form"></span>
                        <span className="space_form"></span>

                        <div className="register_buttons_box">
                            <div className="register_buttons_box_back"><button type="button" name="bt2a" className="button2_form" onClick={back_step}>VOLTAR</button></div>
                            <div className="register_buttons_box_space"></div>
                            <div className="register_buttons_box_next"><button type="submit" name="bt2b" className="button_form" disabled={isUpdate}>{isUpdate ? "AGUARDE ..." : "VALIDAR TOKEN"}</button></div>
                        </div>
                        
                    </form>
                </div>
                </>
                )}

                { step === 2 && 
                (
                <>
                <div className="ft_topico">Alteração realizada</div>
                <div className="ft_descricao">{ alteraItem === 1 ? "Suas informações cadastrais foram alteradas com sucesso." : alteraItem === 2 ? "Seu email foi alterado com sucesso." : "Sua senha foi redefinida com sucesso." }</div>
                <div className="space"></div>
                <img className="register_image" src={icon_success}></img>
                <div className="space"></div>
                <div className="space"></div>
                { alteraItem === 1 ? (
                <>
                <div className="account_success_03">As alterações serão refletivas assim que a página for atualizada</div>
                </>
                ) : (
                <>
                <span className="account_success_02">{firstName(getValues("responsavel"))},</span>
                <span className="account_success_03">depois dessa alteração e para que a nossa plataforma funcione corretamente, é necessário que você faça o login novamente.</span>
                <span className="space_form"></span>
                <div className="account_box_success">
                    <button type="button" name="bt2a" className="button_form" onClick={() => navigate("/login")}>FAZER LOGIN</button>
                </div>
                </>
                )}
                </>
                )}

                <div className="space"></div>
                <div className="space"></div>
                { alteraItem < 2 && (
                <>
                <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
                <div className="space"></div>
                <div className="space"></div>
                </>)}

            </div>
                    
            <Footer access={1}></Footer>
        
        </div>

    )
}